var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex justify-between flex-row items-center flex-wrap"},_vm._l((_vm.status),function(val){return _c('div',{key:val.id},[_c('small-card',{attrs:{"title":val.title,"count":val.count,"link":val.link,"icon":val.icon}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }